export default "__VITE_ASSET__C2Frretq__"